<template>
  <div class="carousel">
    <van-swipe :autoplay="3000" lazy-render :loop="true" :show-indicators="false">
      <!-- <template > -->
      <van-swipe-item v-for="(item, index) in filteredBannerList" :key="index">
        <img :src="item?.url" alt="" class="carouselItem" @click="goToPath(item.redirectUrl)" />
      </van-swipe-item>
      <!-- </template> -->
    </van-swipe>
  </div>
</template>

<script setup lang="ts">
import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { computed, defineProps, onMounted, ref } from 'vue'

const { goToPath } = useNavigation()
const props = defineProps<{
  itemData: {
    banners: BannerItem[]
  }
}>()

const bannerList = ref<BannerItem[]>(props.itemData.banners)

const filteredBannerList = computed(() =>
  bannerList.value.filter(item => item.display)
)
onMounted(() => {
  bannerList.value = props.itemData.banners
})
</script>
<style scoped>
.carousel {
  height: 100%;
  padding: 5px 0;
  border-radius: 15px;
}

.carouselItem {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  /* object-fit: contain; */
}
</style>